import React, {memo, useEffect, useState} from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/lab/Autocomplete";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import Api from "../../utils/api";
import {DIALOG_PAYLOAD} from "../../types";
import {region} from "../../actions";

const AddAddress = (props) => {

    const { id, onComplete } = props;
    const dispatch = useDispatch();
    const AppState = useSelector(state => state);

    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);


    const initStat = {
        postal_code: '',
        reciver_name: '',
        reciver_mobile: '',
        reciver_national_code: '',
        region_id: [],
        main: '',
    }
    const [form, setForm] = useState(initStat);

    useEffect(() => {
        return () => {
            setForm(initStat)
            let n_options = options;
            n_options.splice(1);
            setOptions([...n_options]);
        };
    }, []);

    useEffect(() => {

        if (AppState.region.ready === 'success') {
            let n_options = [];
            n_options[0] = AppState.region.data;
            setOptions([...n_options]);
        }

    }, [AppState.region.ready]);

    useEffect(() => {
        dispatch(region());
    }, []);

    const handleChanger = (event, value, index) => {

        let n_options = options;
        n_options.splice(index + 1);
        setOptions([...n_options]);

        let n_form = form;
        n_form['region_id'].splice(index);
        setForm({...n_form});

        if (value) {

            if ( value.children !== undefined && value.children.length > 0 ) {
                n_options[index + 1] = value.children;
                setOptions([...n_options]);
            }


            let n_form = form;
            n_form['region_id'].splice(index);
            n_form['region_id'][index] = value.id;
            setForm({...n_form});
        }

    };

    const handleChangeElement = (event) => {
        let frm = {...form};
        frm[event.target.name] = event.target.value;
        setForm(frm);
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (form.region_id.length === 0 || form.region_id.length !== options.length) {
            toast.error('موقعیت را به صورت صحیح وارد کنید.');
            return;
        }

        setLoading(true);

        new Api().post("/marketers/" + id + "/address", form)
            .then((res) => {
                if (typeof res !== "undefined") {
                    if (res.status) {
                        toast.success("آدرس با موفقیت ثبت گردید");
                        dispatch({type: DIALOG_PAYLOAD, payload: false})
                        onComplete();
                    } else {
                        toast.error(res.msg);
                    }
                    setLoading(false);
                }
            })
            .catch((err) => {
                toast.error(err);
            })
    }


    return(
        <Dialog
            fullWidth={true}
            onClose={() => dispatch({type: DIALOG_PAYLOAD, payload: false})}
            open={AppState.dialog.open && AppState.dialog.dType === 'ADD_ADDRESS'}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <form onSubmit={handleSubmit} className={'add-address'}>
                <DialogTitle id="alert-dialog-title">ایجاد آدرس جدید</DialogTitle>
                <DialogContent>
                    <fieldset className='add-address-fieldset'>
                        <legend className='add-address-legend'>جزئیات آدرس</legend>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    autoComplete={"off"}
                                    label="نشانی پستی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='main'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    autoComplete={"off"}
                                    type='text'
                                    label="کد پستی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='postal_code'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            {options.map((item , index) => {
                                return(
                                    <Grid item={true} xs={12} sm={4}>
                                        <Autocomplete
                                            autoComplete={'off'}
                                            onChange={((event, value) => handleChanger(event, value, index))}
                                            options={item}
                                            getOptionLabel={(option) => option.title}
                                            renderInput={(params) =>
                                                <TextField
                                                    autoComplete={"off"}
                                                    {...params}
                                                    fullWidth
                                                    name='region_id'
                                                    margin={"dense"}
                                                    label="موقعیت"
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            }
                                        />
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </fieldset>
                    <fieldset className='add-address-fieldset'>
                        <legend className='add-address-legend'>اطلاعات گیرنده</legend>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} >
                                <TextField
                                    autoComplete={"off"}
                                    label="نام و نام خانوادگی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='reciver_name'
                                    value={form.reciver_name}
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <TextField
                                    autoComplete={"off"}
                                    label="موبایل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='reciver_mobile'
                                    value={form.reciver_mobile}
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <TextField
                                    autoComplete={"off"}
                                    type='text'
                                    label="کد ملی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='reciver_national_code'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </fieldset>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => dispatch({ type: DIALOG_PAYLOAD, payload: false})} color="secondary">
                        انصراف
                    </Button>
                    <Button disabled={loading} type={"submit"} color="primary">
                        ایجاد آدرس
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

export default memo(AddAddress);